module.exports = __webpack_public_path__ + "static/img/icon_shop_time.8ccef17e.png";